import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { global } from "@shared/libs/Global";
import {
  getCurrentTime,
  getInitFormData,
  getInitPopUp,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import {
  getEmp,
  getEtcInfo,
  getProgress,
  getRelIssue,
  getTag,
} from "@shared/utils/IssueUtils";
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import FreeForm from "@widgets/FreeForm";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
  Menuprops: menuInfo;
}

/**
 * 이슈정보수정 팝업
 */
const SN_SFA_ISSUE_REP_005_POP_002 = forwardRef(
  ({ selectedData, modalRef, Menuprops }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const formRef = useRef<any>(null);
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    useEffect(() => {
      const fetchform = async () => {
        const rtn = await getInitPopUp("SN_SFA_ISSUE_REP_005_POP_002");
        setFormData(rtn.form.freeform1ControlData);
        setFormControlData(rtn.form.freeform1);
      };
      fetchform();
    }, []);

    useEffect(() => {
      setFormData(selectedData);
    }, [formData]);

    useImperativeHandle(ref, () => ({
      onSave,
    }));

    const onSave = async () => {
      const confirm1 = await showDialog("confirm", "Due date 확인하셨나요?");
      if (!confirm1) return;

      const confirm2 = await showDialog("confirm", "Menu 선택 확인하셨나요?");
      if (!confirm2) return;

      const formData = formRef.current?.getFormdata();
      formData.dt_due = formData.dt_due.replaceAll("/", "");
      const updateData: any = {
        cd_firm: userInfo.cd_firm,
        no_issue: formData.no_issue,
        dc_title: formData.dc_title,
        fg_item: formData.fg_item,
        tm_amd: formData.tm_amd,
        cd_user_amd: userInfo.cd_user,
      };

      // js 데이터 추가
      const js_rel = getRelIssue(formData);
      const js_emp = getEmp(formData);
      const js_tag = getTag(formData);
      const js_progress = getProgress(formData);
      const js_etc_info = getEtcInfo(formData);

      if (js_rel) updateData.js_rel = js_rel;
      if (js_emp) updateData.js_emp = js_emp;
      if (js_tag) updateData.js_tag = js_tag;
      if (js_progress) updateData.js_progress = js_progress;
      if (js_etc_info) updateData.js_etc_info = js_etc_info;

      const saveData = {
        sfa_issue: {
          update: [updateData],
        },
      };

      try {
        const result = await callApi(
          "SN_SFA_ISSUE_REP_005_btnNewIssue",
          saveData
        );

        if (result.status)
          await showDialog("success", "저장이 완료되었습니다.");

        return !!result.status;
      } catch (err) {
        return false;
      }
    };

    const onValueChanged = (data: any, param: string, formData: any) => {
      switch (param) {
        case "cd_menu":
          return {
            nm_menu: data.nm_menu,
            cd_menu: data.cd_menu,
            nm_emp_design: data.nm_emp_design,
            nm_emp_dev: data.nm_emp_dev,
          };
      }
    };

    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          height: "100%",
        }}
      >
        <div
          style={{
            flexShrink: 0,
          }}
        >
          <FreeForm
            ref={formRef}
            data={formData}
            controls={formControlData}
            onValueChanged={onValueChanged}
          />
        </div>
      </div>
    );
  }
);

export default SN_SFA_ISSUE_REP_005_POP_002;
